var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      _vm.state == 0 ||
        _vm.state == 8 ||
        _vm.state == 10 ||
        (!_vm.state && !_vm.token) ||
        (_vm.state == 3 && _vm.userInfo.reapply_time < new Date().getTime())
    )?_c('Home',{attrs:{"userInfo":_vm.userInfo},on:{"getUserInformation":_vm.getUserInformation,"openLoading":_vm.openLoading,"closeLoading":_vm.closeLoading}}):_vm._e(),(
      _vm.state == 4 ||
        _vm.state == 2 ||
        _vm.state == 20 ||
        _vm.state == 6 ||
        (_vm.state == 3 && new Date().getTime() < _vm.userInfo.reapply_time) ||
        _vm.state == 12 ||
        _vm.state == 5
    )?_c('UserState'):_vm._e(),(_vm.state == 22)?_c('FrloanHome',{attrs:{"userInfo":_vm.userInfo},on:{"getUserInformation":_vm.getUserInformation}}):_vm._e(),(_vm.state == 7 || _vm.state == 9 || _vm.state == 11)?_c('RepaymentPage',{on:{"openLoading":_vm.openLoading,"closeLoading":_vm.closeLoading}}):_vm._e(),_c('van-overlay',{attrs:{"show":_vm.loading}},[_c('div',{staticClass:"loadingIcon"},[_c('i',{staticClass:"el-icon-loading"}),_c('p',[_vm._v(" loading... ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }